import React from "react";
import ReactDOM from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initTranslator } from "shared-modules";

initTranslator({ pl: { translation: {} } });

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain="login.futuriti.pl"
      clientId="IcgPwucEZEwFP8Nj23d2oll0rHjWKzo0"
      audience="https://futuritiwms.api.production"
      scope="wms production openid"
      redirectUri={window.location.origin}
      useRefreshTokens
    >
      <App />
    </Auth0Provider>
    ,
  </React.StrictMode>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
